// Only import font weights that are actually used in the codebase
// Based on comprehensive analysis - removes 5 unused weights (100,200,300,800,900)
import '@fontsource/poppins/400.css'; // Normal - forms, body text
import '@fontsource/poppins/500.css'; // Medium - buttons, emphasis
import '@fontsource/poppins/600.css'; // Semibold - headings, labels
import '@fontsource/poppins/700.css'; // Bold - CSS reset, strong emphasis

export const fonts = {
  heading: '"Poppins", sans-serif',
  body: '"Poppins", sans-serif',
};

export type FontTypes = keyof typeof fonts;
